import { RaceProgram, RaceSurface } from "@tvg/ts-types/Race";
import { UnaryFn } from "@tvg/ts-types/Functional";
import { InlinePastPerformance } from "../../../../types";

export interface Props {
  races: InlinePastPerformance[];
  onSelectRace: UnaryFn<number, void>;
  currentRace: RaceProgram;
  currentRaceDistance?: string;
  currentRaceSurface?: RaceSurface;
  isMobile?: boolean;
}

export enum FiltersInlinePP {
  RECENT = "recentRaces",
  TRACK = "trackFilter",
  CONDITION = "conditionsFilter"
}
